import GenericCircuitBenefitAdditionModal, {
  CircuitBenefitAdditionModalProps,
} from './GenericCircuitBenefitAdditionModal';

const AddMealBenefitModal = (props: CircuitBenefitAdditionModalProps) => (
  <GenericCircuitBenefitAdditionModal {...props} modalType="Repas" />
);

export default AddMealBenefitModal;
